import styled from 'styled-components'
import { laptop } from '../../../../common/assets/utils/_breakpoints'

export const LogoImg = styled.img`
  alt: logo;
  height: 32px;
  margin-right: 24px;
`

export const NavBarComponent = styled.div`
  > div {
    &.panel-header {
      display: none;
    }
  }

  @media (min-width: ${laptop}) {
    > div {
      &.panel-header {
        display: block;
      }
      &.is-mobile {
        display: none;
      }
    }
  }
`
